import FileUpload from "components/FileUpload";
import { useTooltip } from "context/TooltipProvider";
import { FC, useState } from "react";
import { editCaseCreationWithupload } from "services/caseServices";
import { CaseCreation } from "types";
import { baseFileURL, LoadingIcon } from "utils/constant";
import { errorHandler, errorHandlerOnForm } from "utils/helper";

type Props = {
  caseData: CaseCreation;
  onClose: (refetch: boolean) => void;
};

const PanelForm: FC<Props> = ({ caseData, onClose }) => {
  const { showTooltip } = useTooltip();
  const [loading, setLoading] = useState(false);

  const [attachment, setAttachment] = useState<File | null>();

  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onClose(false);
    }
  };

  const handleFile = (file: File | null) => {
    setAttachment(file);
  };

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 w-[600px]">
        <h2 className="text-lg font-semibold text-gray-800">Panel Decision</h2>
        <p className="text-xs text-gray-500">
          {caseData?.status === "on_panel" ? (
            <span className="font-semibold text-gray-800">
              You are about to submit a panel decision.
            </span>
          ) : (
            "Are you sure you want to change case to panel?"
          )}
        </p>

        {caseData?.status === "on_panel" && (
          <div className="mt-4">
            <FileUpload
              label="Panel File"
              fileTypes="*"
              info="Upload Files"
              required={false}
              onChange={handleFile}
            />
          </div>
        )}

        <div className="mt-4 flex justify-between gap-2">
          <button
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded w-full hover:bg-gray-300"
            onClick={() => {
              onClose(false);
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className={`border border-[#E90101] bg-[#E90101] px-10 py-2 text-white 
                        font-[Poppins] cursor-pointer font-[500] w-full
                        text-base rounded-md hover:bg-white hover:text-[#E90101]
                        ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
            disabled={loading}
            onClick={() => {
              setLoading(true);
              editCaseCreationWithupload({
                id: caseData?.id,
                upload_panel_decision:
                  caseData?.status === "on_panel" ? attachment : undefined,
                status:
                  caseData?.status === "on_panel"
                    ? caseData?.old_status
                    : "on_panel",
                old_status: caseData?.status,
              })
                .then(() => {
                  setLoading(false);
                  showTooltip("Closed Successfully!", "success");
                  if (caseData?.status !== "on_panel") {
                    window.open(baseFileURL + "/panel-app/", "_blank");
                  }
                  setAttachment(null);
                  onClose(true);
                })
                .catch((error) => {
                  setLoading(false);
                  showTooltip(
                    error?.response?.data?.detail ||
                      errorHandlerOnForm(error) ||
                      errorHandler(error) ||
                      "Something went wrong. Please try again.",
                    "error",
                  );
                });
            }}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                {LoadingIcon}
                Loading...
              </div>
            ) : caseData?.status === "on_panel" ? (
              "Add"
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PanelForm;
